import { API_URL } from '@/lib/api';
import { useTranslation } from 'react-i18next';
import { createFileRoute } from '@tanstack/react-router';
import { GoogleSignInButton } from '@/components/auth/google-sign-in-button';

import { Box, Stack, Typography } from '@mui/material';

interface McpGoogleSearch {
  session?: string;
}

export const Route = createFileRoute('/mcp-google')({
  validateSearch: (search: Record<string, unknown>): McpGoogleSearch => ({
    session: typeof search.session === 'string' ? search.session : undefined,
  }),
  component: McpGooglePage,
});

// A full page navigation rather than an API call: the response is the API's own
// next page, or a redirect back to the MCP client that started the sign-in.
function submitCredential(credential: string, sessionId: string) {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `${API_URL}/auth/mcp/authorize/google`;

  for (const [name, value] of Object.entries({ credential, session_id: sessionId })) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
}

function McpGooglePage() {
  const { t } = useTranslation('auth');
  const { session } = Route.useSearch();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Stack spacing={3} sx={{ width: '100%', maxWidth: 400 }}>
        <Box>
          <Typography variant="h5" gutterBottom>
            {t('mcpGoogle.title', 'Connect with Google')}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {session
              ? t(
                  'mcpGoogle.subtitle',
                  'Sign in with Google to continue connecting your nexmail account. You will confirm what gets access on the next step.'
                )
              : t(
                  'mcpGoogle.missingSession',
                  'This link is incomplete. Start again from the app you are connecting.'
                )}
          </Typography>
        </Box>
        {session && (
          <GoogleSignInButton onCredential={(credential) => submitCredential(credential, session)} />
        )}
      </Stack>
    </Box>
  );
}
